module.exports = __webpack_public_path__ + "img/csi-page-tabs-image-1.44024318.jpg";